import { render, staticRenderFns } from "./RepostaCardCotacaoHeader.vue?vue&type=template&id=f2a71ec8"
import script from "./RepostaCardCotacaoHeader.vue?vue&type=script&lang=js"
export * from "./RepostaCardCotacaoHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports